"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabFrame = void 0;
const react_1 = __importDefault(require("react"));
const FrameContext_1 = require("../context/FrameContext");
const TabFrame = (prop) => {
    const { tab, tabRenderer, classNameExtend } = prop;
    const fc = (0, FrameContext_1.useFrameContext)();
    if (!tab) {
        if (fc.mode === 'right') {
            return null;
        }
        return react_1.default.createElement("div", { className: classNameExtend });
    }
    return tabRenderer(tab, classNameExtend);
};
exports.TabFrame = TabFrame;
TabFrame.defaultProps = {
    classNameExtend: undefined,
};
